import IUserMenu from '../interfaces/IUserMenu';

const ROUTE_FALLBACK_MAP: Record<string, string> = {
  // By ID
  '151': '/home',
  '135': '/user-list',
  '144': '/requests',
  '146': '/special-order',
  '148': '/calendar',
  '141': '/analytics',
  '139': '/voucher',

  // By Name / Label keywords
  overview: '/home',
  dashboard: '/home',
  'employee records': '/user-list',
  employees: '/user-list',
  'tasting events': '/requests',
  requests: '/requests',
  'special orders': '/special-order',
  'company calendar': '/calendar',
  calendar: '/calendar',
  sales: '/analytics',
  reports: '/analytics',
  'voucher requests': '/voucher',
  voucher: '/voucher',
};

export const resolveMenuPath = (menu?: Partial<IUserMenu> | null): string => {
  if (!menu) return '';

  if (menu.path && menu.path.trim().length > 0) {
    return menu.path.trim().replace(/\/+$/, '') || '/';
  }

  if (menu.id && ROUTE_FALLBACK_MAP[String(menu.id)]) {
    return ROUTE_FALLBACK_MAP[String(menu.id)];
  }

  const nameKey = (menu.label || menu.name || '').toLowerCase().trim();
  for (const [key, fallbackPath] of Object.entries(ROUTE_FALLBACK_MAP)) {
    if (nameKey.includes(key)) {
      return fallbackPath;
    }
  }

  return '';
};

export default resolveMenuPath;
